import { Panel } from "@mixitone/components/Controls";
import { ApplicationView } from "@mixitone/mvc";
import React from "react";
import { RegistrationResponse } from "../controllers/PlayerCompetitionsPageController";
import { CompetitionItem } from "./CompetitionItem";

interface CompetitionsListProps {
  title: string;
  registrations: RegistrationResponse[];
  emptyMessage?: string;
}

const UncontrolledCompetitionsList: React.FC<CompetitionsListProps> = ({
  title,
  registrations,
  emptyMessage,
}) => {
  if (registrations.length === 0) {
    return emptyMessage ? (
      <Panel title={title} titleClassName="font-semibold">
        <p className="text-slate-600">{emptyMessage}</p>
      </Panel>
    ) : null;
  }

  return (
    <div>
      <h2 className="mb-5 text-lg font-semibold text-slate-900">{title}</h2>
      <div className="space-y-3">
        {registrations.map((registration) => (
          <CompetitionItem key={registration.id} registration={registration} />
        ))}
      </div>
    </div>
  );
};

const CompetitionsList = ApplicationView(UncontrolledCompetitionsList);
export { CompetitionsList };
